// extracted by mini-css-extract-plugin
export default {"btn":"SmartConsentLogo_btn__4rMHf","btn-success":"SmartConsentLogo_btn-success__WOGCB","logo":"SmartConsentLogo_logo__70gPu"};